var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIndividual6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 29.656,
    viewBox: "0 0 30 29.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#1855f1;}.d{fill:#7097f6;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 29.656
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6.275,32.07a2.306,2.306,0,0,0,.588-1.6,2.5,2.5,0,0,0-5,0,2.559,2.559,0,0,0,.588,1.6A3.622,3.622,0,0,0,0,35.366v3.053a.646.646,0,0,0,.638.63H1.863v4.313a.637.637,0,0,0,1.274,0V37.3a.637.637,0,0,0-1.274,0v.533H1.226V35.414c0-1.357,1.421-2.423,3.137-2.423S7.5,34.057,7.5,35.414v2.423H6.863V37.3a.637.637,0,0,0-1.274,0v6.057a.637.637,0,0,0,1.274,0V39.048H8.089a.645.645,0,0,0,.637-.63V35.366a3.65,3.65,0,0,0-2.451-3.3m-3.137-1.6a1.226,1.226,0,1,1,1.225,1.211,1.151,1.151,0,0,1-1.225-1.211",
    transform: "translate(0 -14.432)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M8.325,52.2a.645.645,0,0,0-.637.63v3.053a.637.637,0,0,0,1.274,0V52.83a.614.614,0,0,0-.637-.63",
    transform: "translate(-3.963 -26.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M41.3,14H38.41a.645.645,0,0,0-.637.63V30.088H36.107V27.617a.645.645,0,0,0-.637-.63h-2.3V22.674a.645.645,0,0,0-.637-.63H29.636a.645.645,0,0,0-.637.63v8.044H27.332v-3.1a.645.645,0,0,0-.637-.63H23.8a.645.645,0,0,0-.637.63v8.625a.645.645,0,0,0,.637.63H41.3a.645.645,0,0,0,.638-.63V14.63A.645.645,0,0,0,41.3,14M29,35.612H27.332V31.929H29ZM24.44,28.2h1.666v7.414H24.44Zm5.833-4.943h1.666V35.612H30.273ZM33.165,28.2h1.666v7.414H33.165Zm2.941,3.1h1.666v4.313H36.107Zm4.558,4.313H39v-20.4h1.666Z",
    transform: "translate(-11.94 -7.216)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M17.769,13.127l-3.726-2.084a1.873,1.873,0,1,0-1.862,1.6,1.972,1.972,0,0,0,1.274-.485l3.725,2.084a1.88,1.88,0,1,0,3.725-.1L23.7,11.334a1.415,1.415,0,0,0,.637,0l2.01,2.52a2.145,2.145,0,0,0-.392,1.26,1.863,1.863,0,0,0,3.725,0,1.876,1.876,0,0,0-2.157-1.841l-2.058-2.52a1.859,1.859,0,1,0-3.284-1.211,1.64,1.64,0,0,0,.441,1.163L20.269,13.03a1.947,1.947,0,0,0-2.5.1m-5.588-1.744a.63.63,0,1,1,.637-.63.645.645,0,0,1-.637.63m6.911,3.731a.63.63,0,1,1,.637-.63.681.681,0,0,1-.637.63m9.362,0a.637.637,0,1,1-.637-.63.645.645,0,0,1,.637.63m-4.412-6.2a.63.63,0,1,1-.637.63.681.681,0,0,1,.637-.63",
    transform: "translate(-5.318 -3.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M.637,1.26H8.774A.645.645,0,0,0,9.411.63.645.645,0,0,0,8.774,0H.637A.645.645,0,0,0,0,.63a.645.645,0,0,0,.637.63",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M12.7,5.73a.645.645,0,0,0-.637-.63H7.112a.63.63,0,1,0,0,1.26h5a.6.6,0,0,0,.588-.63",
    transform: "translate(-3.337 -2.629)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndividual6);
export default __webpack_public_path__ + "static/media/Icon-individual-6.f0e6e8e3a08cc16cce2fbb8cacffb92e.svg";
export { ForwardRef as ReactComponent };